import React from 'react'
import { Form, Select, Radio, Checkbox, DatePicker, Input, Divider } from 'antd'

class AppointmentAttendanceAndCaseCancellation extends React.Component {
  render() {
    return (
      <Form name="appointment-attendance-and-case-cancellation">
        <Form.Item 
          label={
            <React.Fragment>
              PIC 4
              <button className="field-actions">
                Recent changes
              </button>
            </React.Fragment>
          }
        >
          <Select size="large" value="1">
            <Select.Option value="1">Staff</Select.Option>
          </Select>
        </Form.Item>
        <div className="fluid-field checkbox-field">
          <Radio.Group>
            <Radio>None</Radio>
            <Radio>Attended</Radio>
            <Radio>Did not attend</Radio>
            <Radio>Cancelled – No Fee</Radio>
            <Radio>Cancelled with Fee</Radio>
          </Radio.Group>
        </div>

        <Divider className="fluid-field" />
        <h3 className="form-subtitle fluid-field">Attended</h3>
        <div className="fluid-field checkbox-field">
          <Checkbox>Send Report Due Date Notice to Specialist</Checkbox>
        </div>
        <Form.Item label="Date of Attendance" required>
          <DatePicker size="large" />
        </Form.Item>

        <Divider className="fluid-field" />
        <h3 className="form-subtitle fluid-field">Did not attend</h3>
        <Form.Item className="fluid-field" label="Send Non-Attendance Notice to">
          <Checkbox.Group>
            <Checkbox>Booking Solicitor</Checkbox>
            <Checkbox>Booking CM</Checkbox>
          </Checkbox.Group>
        </Form.Item>
        <Form.Item label="Date of Non-Attendance">
          <DatePicker size="large" />
        </Form.Item>
        
        <Divider className="fluid-field" />
        <h3 className="form-subtitle fluid-field">Cancelled – No Fee</h3>
        <Form.Item className="fluid-field" label="Send Cancellation Notice to">
          <Checkbox.Group>
            <Checkbox>Booking Solicitor</Checkbox>
            <Checkbox>Booking CM</Checkbox>
            <Checkbox>Specialist</Checkbox>
          </Checkbox.Group>
        </Form.Item>
        <Form.Item className="fluid-field" label="Update Daysheet for Doctor">
          <Radio.Group>
            <Radio>Yes</Radio>
            <Radio>No</Radio>
          </Radio.Group>
        </Form.Item>
        <Form.Item label="Date of Cancellation">
          <DatePicker size="large" />
        </Form.Item>
        <Form.Item className="fluid-field" label="Reasons">
          <Checkbox style={{ display: 'block', marginBottom: 7 }}>
            At the request of the Case Manager
          </Checkbox>
          <Checkbox style={{ display: 'block', margin: '0px 0px 7px 0px' }}>
            Doctor being unable to undertake assessment
          </Checkbox>
          <Checkbox style={{ display: 'block', margin: 0 }}>
            Doctor being unable to undertake assessment (new appointment details to follow)
          </Checkbox>
        </Form.Item>

        <Divider className="fluid-field" />
        <h3 className="form-subtitle fluid-field">Cancelled with Fee</h3>
        <Form.Item className="fluid-field" label="Send Cancellation Notice to">
          <Checkbox.Group>
            <Checkbox>Booking Solicitor</Checkbox>
            <Checkbox>Booking CM</Checkbox>
            <Checkbox>Specialist</Checkbox>
          </Checkbox.Group>
        </Form.Item>
        <Form.Item className="fluid-field" label="Update Daysheet for Doctor">
          <Radio.Group>
            <Radio>Yes</Radio>
            <Radio>No</Radio>
          </Radio.Group>
        </Form.Item>
        <Form.Item label="Date of Cancellation">
          <DatePicker size="large" />
        </Form.Item>
        <Form.Item className="fluid-field" label="Reasons">
          <Checkbox style={{ display: 'block', marginBottom: 7 }}>
            At the request of the Case Manager
          </Checkbox>
          <Checkbox style={{ display: 'block', margin: '0px 0px 7px 0px' }}>
            Doctor being unable to undertake assessment
          </Checkbox>
          <Checkbox style={{ display: 'block', margin: 0 }}>
            Doctor being unable to undertake assessment (new appointment details to follow)
          </Checkbox>
        </Form.Item>

        <Divider className="fluid-field" />
        <Form.Item label="Comments" className="fluid-field" style={{ marginBottom: 0 }}>
          <Input.TextArea rows={6} />
        </Form.Item>

      </Form>
    )
  }
}

export default AppointmentAttendanceAndCaseCancellation